import { render, staticRenderFns } from "./DeliveryFeesForm.vue?vue&type=template&id=7b09cbf8"
import script from "./DeliveryFeesForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryFeesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports